<template lang="pug">
.k-field-hint(:class="classes")
  v-row(v-if="!quite" no-gutters align="center").k-field-hint__layout
    v-col.align-center.shrink
      k-icon(size="18").pr-3 info
    v-col
      .paragraph--small.k-field-hint__hint.grey-2--text
        slot
  .k-field-hint__layout(v-else)
    .paragraph--small.k-field-hint__hint.brand-warm-grey--text
      slot
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    top: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    side: {
      type: Boolean,
      default: false,
    },
    quite: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    classes () {
      return {
        'k-field-hint--top': this.top,
        'k-field-hint--bottom': this.bottom,
        'k-field-hint--side': this.side,
        'k-field-hint--inline': this.inline
      }
    }
  }
}
</script>

<style scoped lang="scss">
.k-field-hint {
  &__layout {
    @include xs-only {
      align-items: flex-start;
    }
  }

  &__hint {
    @include xs-only {
      padding-top: 3px;
    }
  }

  &--top {
    margin: 9px 0 15px;
  }

  &--inline {
    display: block;
    margin-top: 9px;
    @include sm-and-up {
      display: inline-block;
      margin-top: 0;
    }
  }
}
</style>
